// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"hp-z","breadcrumbForward":"ip-z","breadcrumbBack":"jp-z","selected":"kp-z"};